import { render, staticRenderFns } from "./SurveyCompleted.vue?vue&type=template&id=4565caed&"
import script from "./SurveyCompleted.vue?vue&type=script&lang=ts&"
export * from "./SurveyCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports